export enum ProjectAction {
  'Delete' = 'delete-project',
  'Edit' = 'edit',
  'Favorite' = 'favorite-project',
  'Unfavorite' = 'unfavorite-project',
}
